import { Tooltip } from 'antd';
import React from 'react'

function LayoutPreview(props) {
    const { size = 60, layoutData } = props

    if (!layoutData)
        return null;

    var data = null

    if ((typeof layoutData) === "string")
        data = JSON.parse(layoutData);
    else
        data = layoutData

    const { width = 0, height = 0, slots = [], background_color = "#000", screenSize = null } = data;

    const numWidth = parseFloat(width)
    const numHeight = parseFloat(height)
    const ratio = size / Math.max(numWidth, numHeight);
    const localWidth = numWidth * ratio;
    const localHeight = numHeight * ratio;

    const renderSlots = slots.map(slot => {

        // if (screenSize)
        // ToDo override parent size

        console.log(JSON.stringify(slot))
        const numSlotX = parseFloat(slot.x)
        const numSlotY = parseFloat(slot.y)
        const numSlotWidth = parseFloat(slot.width)
        const numSlotHeight = parseFloat(slot.height)
        const localSlotWidth = numSlotWidth * ratio;
        const localSlotHeight = numSlotHeight * ratio;
        const localSlotX = numSlotX * ratio;
        const localSlotY = numSlotY * ratio;

        return <div key={`${slot.slot_id}`} style={{ position: "absolute", left: localSlotX, top: localSlotY, width: localSlotWidth, height: localSlotHeight, backgroundColor: "#4C4D52", zIndex: slot["z-index"], border: "1px solid #FFFFFF" }}>
        </div>
    })

    return <div className="center-content" style={{ width: `${size}px`, height: `${size}px`, position: "relative", backgroundColor: "#white", ...props.style }}>
        <div style={{ width: `${localWidth}px`, height: `${localHeight}px`, backgroundColor: background_color, position: "relative" }}>
            {renderSlots}</div>
    </div>
}

export default LayoutPreview